import React, { Component } from 'react';
// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Popover from '@material-ui/core/Popover';
import PerfectScrollbar from 'react-perfect-scrollbar';
// Shared components
import PortletContent from 'components/PortletContent';
import { Grid } from '@material-ui/core';
import Loading from '../../../../../utils/Loading'
import {transferPdf, callPdf} from '../../../../../services/transferPdf'
// Component styles
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
import { Typography } from '@material-ui/core';
moment.locale('es')
const api_host_legacy=process.env.REACT_APP_API_LEGACY
const api_host=process.env.REACT_APP_API

class ReportLegacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parentObj:this.props.parentObj,
      obj:this.props.obj,
      isLoad:true,
      isLoad2:true, 
      report:this.props.report,
      horario_id:this.props.horario_id,
      nameSchedule:this.props.nombre_horario,
      scheduleBoolean:this.props.scheduleBoolean,
      periodBoolean:this.props.periodBoolean,
      namePeriod:this.props.namePeriod,
      reportBoolean: this.props.reportBoolean,
      listReport:this.props.listReport,
      indexReport:this.props.indexReport,
      period:this.props.period,
      state:this.props.state,
      loadPdf:false,
      loadWord:false,
      objButton:this.props.objButton,
      pdf:this.props.pdf,
      word:this.props.word,
      csv:this.props.esCsv,
      listObjetivesTypeOne:[62239, 62398, 58116, 58120, 62016], 
      urlFrame:""
    }
  }

  componentDidMount() {
    this.getSpecial()
  }

  static getDerivedStateFromProps(props, state) {
    if(typeof(props.obj)!=="undefined"){
      if (props.obj.id !== state.obj.id) {
        return {
            isLoad2:true,
            isLoad:true,
            obj:props.obj,
            report:props.report
        }
      }
    }
    
    if(props.horario_id!==state.horario_id){
      return {
        isLoad:true,
        horario_id:props.horario_id,
        report:props.report,
        isLoad2:true,
      }
    }
    if(props.namePeriod!==state.namePeriod){
      return {
        isLoad:true,
        namePeriod:props.namePeriod,
        report:props.report,
        isLoad2:true,
        period:props.period,
        state:props.state
      }
    }
    if(props.indexReport!==state.indexReport||props.report!==state.report){
      return {
        isLoad:true,
        indexReport:props.indexReport,
        listReport:props.listReport,
        isLoad2:true,
        report:props.report,
      }
    }
    return null;
  }
  componentDidUpdate(prevProps, prevState) {
    if(typeof(prevProps.obj)!=="undefined"){
      if(prevProps.obj.id!== this.state.obj.id){
        this.getSpecial();
      }
    }
    if(prevProps.horario_id!== this.state.horario_id||prevProps.namePeriod!== this.state.namePeriod
      ||prevProps.indexReport!==this.state.indexReport||prevProps.report!==this.state.report){
        this.getSpecial();
    }
  }

  getSpecial =()=>{
    const {obj, parentObj, isLoad2, scheduleBoolean,periodBoolean,horario_id, word,pdf,
      reportBoolean, listReport, objButton, period, state, listObjetivesTypeOne, csv}=this.state
    const user = sessionStorage.getItem('user')
    var type=0
    if (listObjetivesTypeOne.includes(parentObj)){
      type=1
    }
    var url=api_host_legacy+"/acceso_especial.php?acceso_pdftohtml=1&es_pdf=false&type="+type+"&es_especial=1&tiene_svg=1"
    var data =(JSON.parse(sessionStorage.getItem("specialObjectiveData")))
    if(data.especial===false){
      url=url.replace("&es_especial=1", "")
      url=url.replace("&es_especial=0", "")
    }
    //console.log(url)
    var final=moment()
    var begin=moment()
    if(periodBoolean===true){
      if(period==="d"){
        begin=moment().subtract({"days":1})
      }
      if(period==="3d"){
        begin=moment().subtract({"days":2})
      }
      if(period==="w"){
        begin=moment().subtract({"days":6})
      }
      if(period==="c"){
        if(moment(state.startDate).format("YYYY-MM-DD") === moment(state.endDate).format("YYYY-MM-DD") 
          && moment(state.startDate).format("YYYY-MM-DD") != moment().format("YYYY-MM-DD")){
          begin=moment(state.startDate)
          final=moment(state.endDate)
        }
        else if(moment(state.startDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")){
          begin=moment(state.startDate)
          final=moment()
        }
        else{
          const formattedBegin = new Date(state.startDate)
          const formattedFinal = new Date(state.endDate)

          begin=moment(formattedBegin.setHours(0,0,0))
          final=moment(formattedFinal.setHours(0,0,0))
        }
      }
      url+="&fecha_inicio="+String(begin.format("YYYY-MM-DD HH:mm:ss "))+"&fecha_termino="+String(final.format("YYYY-MM-DD HH:mm:ss ")) 
    }
    if(scheduleBoolean===true){
      url+="&horario_id="+horario_id 
    }
    var typesSpecial=JSON.parse(sessionStorage.getItem("typesSpecial"))
    if(reportBoolean===true){
      if(typeof(state.startDate)==="undefined"){
        final=moment().subtract({"months":1})
        begin=moment().subtract({"months":1})
      }
      if(parseInt(listReport.dia_termino.substring(8,10))>moment().day()&&parseInt(listReport.dia_inicio.substring(8,10))<moment().day()){
        begin=listReport.dia_inicio
        final=listReport.dia_termino
      }else{
        //console.log('fecha mayor',listReport.dia_inicio, listReport.dia_termino)
        begin=listReport.dia_inicio
        if(listReport.dia_termino.substring(8,10)==="01"){
          final=final.add(1, "M").startOf("month").format("YYYY-MM-DD")
        }else{
          final=listReport.dia_termino
        }
      }
      //console.log(begin, final)
      url+="&fecha_inicio="+begin+"&fecha_termino="+final
      //console.log(url)
      if(typesSpecial[0].informe_id==="170"||typesSpecial[0].informe_id==="178"||typesSpecial[0].informe_id==="181"){
        url+="&word=1"
      }
    }
    if(objButton===true){
      url+="&subobjetivo_id="+obj.id
    }
    if(word===true||JSON.parse(sessionStorage.getItem("setupSpecial")).contraloria==="true"){
      url+="&word=1"
    }
    url+="&objetivo_id="+parentObj+"&usuario_id="+user
    
    if(typesSpecial[0].informe_id==="152"){
      url=url.replace("&type=0", "&type=1")
    }
    if(typesSpecial[0].informe_id==="178"){
      url+="&word=1"
    }
    if(typesSpecial[0].informe_id==="163"||typesSpecial[0].informe_id==="173"){
      url+="&word=1"
      let _final=String(final.format("YYYY-MM-DD HH:mm:ss")) 
      let _begin=String(begin.format("YYYY-MM-DD HH:mm:ss")) 
      if (_begin == _final){
        final=(final).format("YYYY-MM-DD")+" 23:59:59"
        url=url.replace("&fecha_termino="+_final, "&fecha_termino="+final)
      }
      url.replace(" ", "%20")
    }
    var data=<object   style={{height:"800px", width:"100%"}} type="text/html" data={url}></object>
    //console.log('sad',csv, pdf, word)
    if(csv===true && (pdf===false && word===false)){
      //console.log('sin iframe', url)
      this.setState({
        isLoad: false,
        urlFrame:url.replace(" ", "%20"),
        isLoad2:false
      });
    }else{
      //console.log('iframe')
      this.setState({
        isLoad: false,
        data:data, 
        urlFrame:url.replace(" ", "%20")
      });
      //console.log('up load2', isLoad2)
      if(typesSpecial[0].informe_id==="163"||typesSpecial[0].informe_id==="173"){
        setTimeout(() => this.setState({ 
          isLoad2:false
        }),60000);
      }else{
        setTimeout(() => this.setState({ 
          isLoad2:false
        }),20000); 
      }
      
    }
  }
  

  print =(valueBoolean)=>{
    const {obj, report, word, urlFrame}=this.state
    const token = sessionStorage.getItem('key')
    const user = sessionStorage.getItem('user')
    var url=urlFrame.replace('acceso_pdftohtml=1', '')
    var typesSpecial=JSON.parse(sessionStorage.getItem("typesSpecial"))
    if(typesSpecial[0].informe_id==="163"||typesSpecial[0].informe_id==="173"){
      url+="&word=1"
    }
    var type=typesSpecial.filter(i=>i["content-type"]==="pdf")[0].order
    url=url.replace('type=0', 'type='+type)
    //console.log('print', url)
    var popup = window.open(url)
    popup.blur();
    window.focus();
    this.setState({
      loadPdf: true,
    });
    if(typesSpecial[0].informe_id==="163"||typesSpecial[0].informe_id==="173"){
      setTimeout(() => this.setState({ 
        isLoad2:false,
        loadPdf: false
      }),60000);
    }else{
      setTimeout(() => this.setState({ 
        isLoad2:false,
        loadPdf: false
      }),20000); 
    }
    
  }
  callWord =(valueBoolean)=>{
    const {obj, report, urlFrame}=this.state
    const token = sessionStorage.getItem('key')
    const user = sessionStorage.getItem('user')
    const types=JSON.parse(sessionStorage.getItem("typesSpecial"))
    //console.log(types)
    //console.log(types.filter(i=>i["content-type"]==="doc")[0].order)
    var url=urlFrame.replace('type=1', 'type='+types.filter(i=>i["content-type"]==="doc")[0].order)
    url=urlFrame.replace('type=0', 'type='+types.filter(i=>i["content-type"]==="doc")[0].order)
    //console.log(url)
    window.open(url)
    this.setState({
        loadWord: true,
    });
    setTimeout(() => this.setState({ 
      loadWord:false
    }),5000);
  }

  callCsv =()=>{
    const {urlFrame}=this.state
    var typesSpecial=JSON.parse(sessionStorage.getItem("typesSpecial"))
    var typeXls=typesSpecial.filter(i=>i["content-type"]==="xls")
    var typeCsv=typesSpecial.filter(i=>i["content-type"]==="csv")
    var url=urlFrame
    
    if(typeXls.length>0){
      url=url.replace('type=1', 'type='+typeXls[0].order)
      url=url.replace('type=0', 'type='+typeXls[0].order)
    }else{
      url=url.replace('type=1', 'type='+typeCsv[0].order)
      url=url.replace('type=0', 'type='+typeCsv[0].order)
    }
    //console.log("csv", url)
    var popup = window.open(url.replace(" ", "%20"))
        popup.blur();
        window.focus();
  }


  render() {
    const{obj, isLoad, page, data, isLoad2, loadPdf, objButton, pdf, word, loadWord, csv}=this.state
    
    //console.log('render', isLoad, isLoad2)
    if(isLoad===true){
      //console.log('render load1')
      return (
        <PortletContent style={{height:"100%"}}>
          <Loading />
        </PortletContent>
        
      )
    }else{
      var display="hidden"
      var load=""
      if(isLoad2===false){
        display=""
        load="hidden"
      }
      //console.log('render2', pdf)
      return(
        <PortletContent style={{height:"100%"}}>
           <Grid
            container
            spacing={1}
            style={{visibility:load}}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              xl={12}
              style={{textAlign:"center"}}
            >
              <Loading text={" Por favor, espere mientras se genera reporte con elementos visuales, esto podría tardar unos minutos"}/>
            </Grid>
          </Grid>
          <Grid
          
            container
            spacing={1}
            style={{visibility:display}}
          >
            {objButton?
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              xl={12}
            >
              <Typography variant="h3" style={{ color:'#66788A'}}  >{obj.nombre}</Typography>
            </Grid>
            :null}
            {pdf?
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                style={{textAlign:"left"}}
              >
                <Button onClick={this.print.bind(this,true)}>
                  <Typography variant="h4" style={{ color:'#66788A'}}>Descargar PDF</Typography>
                </Button>
              </Grid>
            :null}
            {word?
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                style={{textAlign:"left"}}
              >
                {loadWord?
                  <Loading text={"Cargando documento"}/>
                  :
                  <Button onClick={this.callWord.bind(this,true)}>
                    <Typography variant="h4" style={{ color:'#66788A'}}>Doc</Typography>
                  </Button>
                }
              </Grid>
            :null}
            {csv?
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                style={{textAlign:"left"}}
              >
                <Button onClick={this.callCsv}>
                  <Typography variant="h4" style={{ color:'#66788A'}}>Descarga Csv</Typography>
                </Button>
              </Grid>
            :null}
            
            <Grid
              
              item
              xs={12}
              sm={12}
              md={12}
              xl={12}
            >{/* <PerfectScrollbar> */}
              <Grid
                container
                spacing={1}
                style={{height:"800px"}}
              >
                  {data}
                </Grid>
            {/*   </PerfectScrollbar> */}
            </Grid>
            
          </Grid>
          
        </PortletContent>
      )
    }
  }
}

ReportLegacy.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReportLegacy);